const context = require.context('./../../../public/images/login', false, /\.(jpeg|jpg|png)$/);

const images = context.keys().map(context);

export default images;
